import { DashboardsData } from './types';

export const initialState: DashboardsData = {
  presetId: '',
  sorting: [],
  saved: true,
  source: 'scheduled',
  columns: {
    records: [],
    isLoading: true,
  },
  preview: [[[]]],
  removedColumns: [],
  selectedColumns: [],
  checkedColumns: [],
  joinedColumns: [],
  initialColumns: [],
  columnWidths: {},
  dialog: {
    column: {
      details: false,
      edit: false,
      settings: false,
      remove: false,
      values: {},
    },
    preset: {
      details: false,
      remove: false,
      values: {},
    },
  },
  tooltip: 0,
};
